import type { ReactNode } from "react";
import { Feedback, type FeedbackSize, type FeedbackStatus } from "../internal/Feedback";

export type AlertStatus = Extract<FeedbackStatus, "success" | "error" | "warning" | "info">;
export type AlertSize = FeedbackSize;

interface AlertActionProps {
  href?: string;
  label: string;
  onPress?: () => void;
}

function AlertAction({ href, label, onPress }: AlertActionProps) {
  return <Feedback.Action label={label} href={href} onPress={onPress} />;
}

export interface AlertProps {
  children?: ReactNode;
  description: string | string[];
  onClose?: () => void;
  /** Visual scale. `"md"` (default) is the standalone surface size. Use `"sm"` inside modals or dense layouts. */
  size?: AlertSize;
  status: AlertStatus;
  title: string;
}

export function Alert({ children, description, onClose, size, status, title }: AlertProps) {
  return (
    <Feedback.Root size={size} status={status} title={title} description={description} onClose={onClose}>
      {children}
    </Feedback.Root>
  );
}

Alert.Action = AlertAction;
